const drawerWidth = 200;
export const useStyles = (theme) => ({
  root: {
    marginLeft: drawerWidth,
    minHeight: "100vh",
    padding: 30,
    marginTop: 50,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
  title: {
    display: "flex",
    alignItems: "center",
  },
  refresh: {
    cursor: "pointer",
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  nameinputStyle: {
    outline: "none",
    width: "49%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
  tooltip: {
    color: "#0a1f3a",
    "&:hover": {
      cursor: "pointer",
    },
  },
});
